import React from 'react';
import { Divider } from 'antd';
import { useSelector } from 'react-redux';

import { version } from '../../package.json';

import colors from '../constants/Colors';

import { safeExtractFromObject } from '../helpers/helpers';

export default function Version() {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const hasRedesign = settings?.uxRedesignPt1;
  return (
    <div
      id="menu-version-container"
      style={{
        backgroundColor: hasRedesign
          ? colors.REDESIGN_PRIMARY_TEXT
          : colors.ONTRACCR_BLACK,
      }}
    >
      <div
        id="menu-version-divider-container"
        style={{
          padding: hasRedesign
            ? 0
            : '0px 15px',
        }}
      >
        <Divider style={{
          backgroundColor: hasRedesign
            ? colors.REDESIGN_BUTTON_UNSELECTED_TEXT
            : colors.opacity(colors.LIGHT_GRAY, 0.4),
          padding: hasRedesign
            ? 0
            : '0px 15px',
          height: 1,
          margin: 0,
        }}
        />
      </div>
      <div
        id={hasRedesign ? 'menu-version-redesign' : 'menu-version'}
      >
        {`v${version}`}
      </div>
    </div>
  );
}
